import moment from 'moment';

import { Tenant } from '@hooks/useComponentMapping';

import 'moment/locale/it';

export function setMomentLocale(tenantId: Tenant, lang: string): void {
  moment.locale(lang);
}
